import * as R from "ramda";
import { downloadCSV } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";

export const completedSessionExporter = sessions => {
  const sessionsForExport = sessions.map(session => {
    const {
      completionSummary,
      devices,
      platformInfo,
      patientInfo,
      program,
      ...restSession
    } = session;
    restSession.os = R.pathOr("", ["os"], platformInfo);
    restSession.completness = R.pathOr(
      "",
      ["completionPercent"],
      completionSummary
    );
    restSession.devicesNumber = R.length(devices);
    restSession.serials = devices.map(d => d.serialNumber);
    restSession.program = R.pathOr("", ["defaultParameters", "type"], program);
    restSession.maxIntensity = R.pathOr(
      "",
      ["intensitySummary", "max"],
      completionSummary
    );
    restSession.longestIntensity = R.pathOr(
      "",
      ["intensitySummary", "longest"],
      completionSummary
    );
    restSession.endDate = R.pathOr("", ["finishDate"], completionSummary);
    restSession.patient = R.pathOr("", ["id"], patientInfo);
    restSession.painScoreAfter = R.pathOr(
      "",
      ["painScoreAfter"],
      completionSummary
    );

    return restSession;
  });
  const csv = convertToCSV({
    data: sessionsForExport,
    fields: [
      "id",
      "doctor",
      "patient",
      "os",
      "completness",
      "mode",
      "devicesNumber",
      "serials",
      "program",
      "muscleGroup",
      "type",
      "maxIntensity",
      "longestIntensity",
      "painScoreBefore",
      "painScoreAfter",
      "startDate",
      "endDate",
      "expectedFinishDate"
    ]
  });
  downloadCSV(csv, "completed_sessions");
};

export const runningSessionExporter = sessions => {
  const sessionsForExport = sessions.map(session => {
    const {
      completionSummary,
      devices,
      platformInfo,
      patientInfo,
      program,
      ...restSession
    } = session;
    restSession.os = R.pathOr("", ["os"], platformInfo);
    restSession.devicesNumber = R.length(devices);
    restSession.serials = devices.map(d => d.serialNumber);
    restSession.program = R.pathOr("", ["defaultParameters", "type"], program);
    restSession.patient = R.pathOr("", ["id"], patientInfo);

    return restSession;
  });
  const csv = convertToCSV({
    data: sessionsForExport,
    fields: [
      "id",
      "doctor",
      "patient",
      "os",
      "mode",
      "devicesNumber",
      "serials",
      "program",
      "muscleGroup",
      "type",
      "painScoreBefore",
      "startDate",
      "expectedFinishDate"
    ]
  });
  downloadCSV(csv, "running_sessions");
};
